module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/fluent-app-icon-7.2d04564e.png";